import * as types from './mutation-types'

const matutaions = {
    // 域名(跳转地址)
    [types.SET_JUMPLINK] (state, jumplink) {
        state.jumplink = jumplink
    },
    // 登录人信息
    [types.SET_USER_INFO] (state,userInfo){
        state.userInfo = userInfo
    },
    // 个人中心信息
    [types.SET_OWNER_INFO] (state,ownerInfo){
        state.ownerInfo = ownerInfo
    },
    // 个人中心信息
    [types.SET_OWNER] (state,owner){
        state.owner = owner
    },
    // 主题图
    [types.SET_THEMEIMG] (state,themeImg){
        state.themeImg = themeImg
    },
    // 同步登录页配置数据
    [types.SET_LOGIN_CONFIG] (state, config) {
      state.loginConfig = config
    }
}

export default matutaions;



// WEBPACK FOOTER //
// ./src/store/mutations.js